
import {Check} from "@sparkware/app-utils";
import {Nullable} from "../../../../../../common/types/nullable-types";
import {VideoSlidesFilterListPreviewComponent} from "../../../../../components/video-slides/filter-preview/video-slides-filter-list-preview.component";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {VideoSlidesFilterConfig} from "../../arenas/arena-base.model";

export class VideoSlidesFilterPreviewModel {
    constructor(private readonly services: IServiceFactoryExtended, public readonly arenaName: string,
        private readonly _videoSlidesFilterConfig: Nullable<VideoSlidesFilterConfig>) {
    }

    private _shouldRenderVideoSlidesFilter(listPosition: number): boolean {
        if (!Check.isNullOrUndefined(this._videoSlidesFilterConfig) &&
            this.services.videoSlides.shouldBeDisplayed &&
            listPosition === this._videoSlidesFilterConfig.position) {
            return true;
        }

        return false;
    }

    render(listPosition: number): React.ReactElement {
        if (!this._shouldRenderVideoSlidesFilter(listPosition)) {return null}

        return (<VideoSlidesFilterListPreviewComponent filterIdList={this._videoSlidesFilterConfig.filterIds} hasHeaderButton={false} height="15" />)
    }
}